"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayLoginButton = exports.DiagonalDivider = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const constants_1 = require("../../../../assets/constants/constants");
exports.DiagonalDivider = styled_components_1.default.div `
  @media only screen and (min-width: ${constants_1.SCREEN_WIDTH.mobile + 1}px) {
    position: relative;
    display: ${props => (props.display ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    width: 50px;
    margin: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -16px;
      width: 80px;
      height: 1px;
      background-color: #707070;
      transform: translateY(-60%) rotate(-65deg);
      z-index: -1;
    }

    &::after {
      content: '';
      position: absolute;
      width: 25px;
      height: 25px;
      z-index: 1;
      background-color: #f6f6f6;
    }

    & > span {
      position: absolute;
      z-index: 2;
    }
  }

  @media only screen and (max-width: ${constants_1.SCREEN_WIDTH.mobile}px) {
    display: flex;
    .diagonal-divider-line{
      margin: 10px;
      height: 1px;
      background-color: #707070;
      width: 100%;
    }
  }
`;
exports.DisplayLoginButton = (0, styled_components_1.default)(antd_1.Col) `
  display: ${props => (props.display ? 'flex' : 'none')};
`;
